import { render, staticRenderFns } from "./VCalendar.vue?vue&type=template&id=fb8f0a4a&"
import script from "./VCalendar.vue?vue&type=script&lang=js&"
export * from "./VCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports